import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, SUB_TITLE} from "./MigrateServicesSpecializationConstants";


// Images

import allInOne from '../../../assets/img/partnerPortal/migrateServices/all-in-one.png';
import scalability from '../../../assets/img/partnerPortal/appDeveloper/scalability.png';
import appDeveloperBackground from '../../../assets/img/partnerPortal/appDeveloper/fullWaveApp.png';
import checkmark from '../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg';
import checkmarWhite from '../../../assets/img/partnerPortal/appDeveloper/checkmark-white.svg';
import cloudOps from '../../../assets/img/partnerPortal/appDeveloper/cloudOps.png';
import migrateBadge from '../../../assets/img/partnerPortal/migrateServices/migration_badge.png';


// Scss
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/partnerPortal/welcome.scss';
import '../../../assets/css/partnerProgram.scss';


import Image from "react-bootstrap/Image";
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";
import ContentBlock from "../../../components/ContentBlock";

function MigrateServicesSpecialization() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <div className="mb-3">
            <BannerOne bannerImage={appDeveloperBackground} title={TITLE} hasNoButton={true} subTitle={SUB_TITLE}  />
            <div className="containerAll">
                <TitleSubTitleCenter sectionWidth="width80" title={"Equip yourself with the methodologies, tooling, and best practices to help your customers seamlessly migrate to Dynatrace SaaS"} 
                    subTitle={"Many organizations today are looking to move to SaaS based solutions, but not all. Why? Because the migration process isn’t as easy or " +
                                "seamless as organizations think when you have to do it alone. But our joint customers don’t need to worry about that."} />
                 <div className="productSection w-100 mt-4 mb-5">
                    <div className="d-flex flex-column justify-content-center align-items-start" >
                        <Image src={migrateBadge}  width={"100%"} />
                    </div>
                    <div className="productCheckPoint">
                        <div className="contactGeneral fontWeight400 fontSize18">
                            <b>Dynatrace Migration Specialization</b>
                            <br/>
                            <br/>
                            Dynatrace Migration Specialization provides you with the opportunity to become certified as a Dynatrace Migration expert, 
                            and help our joint customers seamlessly migrate from Dynatrace Managed to Dynatrace SaaS, reaping the rewards SaaS has to offer.
                                <br></br><br></br>
                                <div><b>You’ll learn how to migrate and enable:</b></div>
                        </div>
                        <div className="productItem mb-3 mt-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Agent Deployments
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Platform Configurations
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            User Accounts
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Dashboards
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Training for users
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="w-100 mt-5 d-flex align-items-center flex-column">
                    <div className="introframeHeader width80 mx-auto">
                        Why migrate customers to Dynatrace SaaS?
                    </div>
                    <div className="d-flex align-items-start w-100 justify-content-center">
                        <div className="cardCol mt-5">
                                <img src={allInOne} alt='...'  />
                                <div className="cardColText">Leverage all modules of the Dynatrace Platforms</div>
                                <div className="cardColSubText">Including Grail, Application Security, and more.</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={scalability} alt='...'  />
                            <div className="cardColText">Scale the use of Dynatrace as needed</div>
                            <div className="cardColSubText">to reach the changing goals of your customers' organizations.</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="d-flex flex-column align-items-start mt-5 margin96Botton">
                <div className="d-flex flex-column align-items-center waveImage w-100">
                    <div className="displayFlex align-items-center justify-content-center width67 m-auto ">
                        <div className="d-flex flex-column align-items-center justify-content-center width40 ">
                            <div className="d-flex align-items-start " >
                                <div className="textStyle">What’s in it for you?</div>
                            </div> 
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center width55 ">
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                Become industry-recognized with the necessary skills and best practices to successfully migrate and win these associated customer engagements
                                </div>
                            </div>
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                Leverage the tools and techniques our teams utilize and learn how to adopt these in major projects for seamless migration
                                </div>
                            </div>
                            <div className="productItem mb-3">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                Migrate more customers and take advantage of being able to cross-sell the platform capabilities and expand into new modules, bringing new revenue opportunities
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5">
                <ContentBlock image={cloudOps} sectionWidth="width64" frameTitle={"Pre-requisites"} 
                                sectionOneText={<div className="mb-2">- <b>Individuals</b> must hold their Services Observability Certification.</div>}
                                sectionTwoText={<div>- <b>Organizational</b> endorsement is achieved by having <b>four Observability Services Certified Individuals, two Dynatrace Migration Specialized Individuals, and two referenceable customers.</b></div>}  />
            </div>
            

            <div className="d-flex flex-column align-items-start margin96Botton mt-5 ">
                <div className="d-flex flex-column align-items-center justify-content-center bannerAppDeveloper width67 m-auto">
                    <div className="d-flex flex-column align-items-center width63">
                        <div className="d-flex align-items-stretch mb-4">
                            <div className="textStyle">Ready to get started?</div>
                        </div>
                        <div className="d-flex align-items-center align-self-stretch mb-3 ">
                            <div className="subTextBannerStyle text-center">
                            Become a Dynatrace Migration expert and drive flawless SaaS migrations, transform challenges into opportunities, and guide your clients toward a brighter digital future. Take the first step today.

                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center align-self-stretch ">
                            <a href={"https://university.dynatrace.com/certification/42509"} target="_blank" className="w-100 d-flex justify-content-center"  >
                                <div className="d-flex align-items-center justify-content-center width39 buttonBackground">
                                    <div className="buttonLettersStyle buttonBlack">Enroll now</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default MigrateServicesSpecialization;

